import { Card, Grid, Typography } from "@mui/material";

interface Parameters {
    color: string,
    main: string,
    label: string,
    value: string,
    onClick?: () => void;
}

const Cards = ({ color, main, label, value, onClick }: Parameters) => {
    return (
        <Card sx={{
            padding: '0 8px',
            backgroundColor: color,
            boxShadow: '0 2px 5px #a8a8a8ff',
            cursor: 'pointer',
        }}
            onClick={onClick}
        >
            <Grid container alignItems='center'>
                <Grid item xs={2}>
                    <Typography color='#ffffffff' fontWeight={500} fontSize={42}>
                        {main}
                    </Typography>
                </Grid>
                <Grid xs={10} sx={{ textAlign: 'right' }}>
                    <Typography color='#ffffffff' fontWeight={500} fontSize={18} lineHeight={1.3}>
                        {label}<br />
                        {value}
                    </Typography>
                </Grid>
            </Grid>
        </Card>
    )
}

export default Cards;